export const CLASS_NAME_PREFIX = 'react-carousel-responsive__';
